import { CredentialResponse } from '@react-oauth/google'
import { Country } from '../../types'
import customerBffFetch from './customer-bff-fetch'
import { AuthenticateWithGoogleResponse } from './types'

export class AuthService {
  static async googleLogin(
    credentialResponse: CredentialResponse,
    country: Country,
  ): Promise<AuthenticateWithGoogleResponse> {
    try {
      const { data } = await customerBffFetch.post('/google/auth', {
        credential: credentialResponse.credential,
        country,
      })

      return data
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Error en la autenticación con Google'
      throw new Error(errorMessage)
    }
  }
}
